import { User } from "../@core/data/users";

export default class Notification {
  id?: string;
  type?: string;
  mode?: string;
  refId?: string;
  refUrl?: string;
  fromId?: string;
  fromTitle?: string;
  fromDescription?: string;
  fromUid?: string;
  fromAuthor?: User;

  toUid?: string;
  isReceived?: boolean;
  receiveOn?: Date;
  //action link
  actions?: string;

  //view in page detail
  courseId?: string;

  //render
  iconType?: string;
  preTitle?: string;
  iconMode?: string;
  navigateUrl?: string;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
